import axios from 'axios';
import 'chart.js/auto'; // Import to register the controller and chart type.
import React, { useEffect, useState } from 'react';
import { buildApiUrl } from '../../../../utils/apiUrl';
import { Bar } from 'react-chartjs-2';

const BarChartComponent = () => {
	const [chartData, setChartData] = useState({
		labels: ['SoMe Pro', 'Reach Pro', 'Reach Elite', 'Content Premium'],
		datasets: [
			{
				data: [0, 0, 0, 0],
				backgroundColor: [
					'rgba(255, 99, 132, 0.2)',
					'rgba(54, 162, 235, 0.2)',
					'rgba(255, 206, 86, 0.2)',
					'rgba(75, 192, 192, 0.2)',
				],
				borderColor: [
					'rgba(255, 99, 132, 1)',
					'rgba(54, 162, 235, 1)',
					'rgba(255, 206, 86, 1)',
					'rgba(75, 192, 192, 1)',
				],
				borderWidth: 1,
			},
		],
	});

	useEffect(() => {
		const fetchChartData = async () => {
			try {
				const response = await axios.get(
					buildApiUrl('statistics/monthly-order-stats')
				);
				const d = response.data;
				const n = (v) => {
					const x = Number(v);
					return Number.isFinite(x) ? x : 0;
				};

				setChartData({
					labels: ['SoMe Pro', 'Reach Pro', 'Reach Elite', 'Content Premium'],
					datasets: [
						{
							data: [
								n(d.soMeProCount),
								n(d.reachProCount),
								n(d.reachEliteCount),
								n(d.contentPremiumCount),
							],
							backgroundColor: [
								'rgba(255, 99, 132, 0.2)',
								'rgba(54, 162, 235, 0.2)',
								'rgba(255, 206, 86, 0.2)',
								'rgba(75, 192, 192, 0.2)',
							],
							borderColor: [
								'rgba(255, 99, 132, 1)',
								'rgba(54, 162, 235, 1)',
								'rgba(255, 206, 86, 1)',
								'rgba(75, 192, 192, 1)',
							],
							borderWidth: 1,
						},
					],
				});
			} catch (error) {
				console.error('Error fetching chart data:', error);
			}
		};

		fetchChartData();
	}, []);

	const options = {
		plugins: {
			legend: {
				display: false,
			},
		},
		scales: {
			y: {
				beginAtZero: true,
			},
		},
	};

	return <Bar data={chartData} options={options} />;
};

export default BarChartComponent;
